import { useContext } from "react";
import { SimulatedCostDispatchContext } from "../SimulationProvider";

export const useSimulatedCostDispatch = () => {
  const dispatcher = useContext(SimulatedCostDispatchContext);
  if (!dispatcher) throw new Error("SimulatedCostDispatchProvider not found");

  return dispatcher;
};
